import {
  Kontaktdaten,
  KontaktdatenResponseType,
} from "../../../api";

export interface ExtendedKontaktdaten extends KontaktdatenResponseType {
  kontaktdatenGPDB?: Array<Kontaktdaten>;
  kontaktdatenFAZ?: Array<Kontaktdaten>;
  vorname?: string;
  nachname?: string;
  strasse?: string;
  strasseSA?: number;
  hausnummer?: string;
  zusatz?: string;
  postfach?: string;
  plz?: string;
  ort?: string;
  staat?: string;
  staatBezeichnung?: string;
  tel?: string;
  tel_land?: string;
  tel_vorwahl?: string;
  tel_nummer?: string;
  mobil?: string;
  mobil_land?: string;
  mobil_vorwahl?: string;
  mobil_nummer?: string;
  email?: string;
}


export const emptyKontaktdaten: ExtendedKontaktdaten = {
    email: "",
    hausnummer: "",
    mobil: "",
    mobil_land: "+43",
    mobil_vorwahl: "",
    mobil_nummer: "",
    ort: "",
    plz: "",
    postfach: "",
    strasse: "",
    strasseSA: undefined,
    tel: "",
    tel_land: "+43",
    tel_vorwahl: "",
    tel_nummer: "",
    zusatz: "",
  };

  export const emptyKontaktdatenAustria: ExtendedKontaktdaten = {
    email: "",
    hausnummer: "",
    mobil: "",
    mobil_land: "+43",
    mobil_vorwahl: "",
    mobil_nummer: "",
    ort: "",
    plz: "",
    postfach: "",
    strasse: "",
    strasseSA: undefined,
    tel: "",
    tel_land: "+43",
    tel_vorwahl: "",
    tel_nummer: "",
    zusatz: "",
    staat: "AT",
    staatBezeichnung: "Österreich",
  };